export default __webpack_public_path__ + "static/prompt-d581becc22d8e2410a6d4c1156bcc89e.png";